import React from "react";
import AntdTabs, {TabsProps} from "antd/lib/tabs";
import {withError} from '@fishx/tracker';

const TabPane = AntdTabs.TabPane;

interface TProps extends React.FC<TabsProps> {
  TabPane: typeof TabPane;
}

export const Tabs: TProps= (props) => (
  <AntdTabs {...props} />
)
Tabs.TabPane = TabPane;
Tabs.displayName = 'Tabs';
export default withError(Tabs);



// WEBPACK FOOTER //
// ./src/components/tabs/index.tsx